import { render, staticRenderFns } from "./AboutPageModal.vue?vue&type=template&id=d2939b74&scoped=true&"
import script from "./AboutPageModal.vue?vue&type=script&lang=js&"
export * from "./AboutPageModal.vue?vue&type=script&lang=js&"
import style0 from "./AboutPageModal.vue?vue&type=style&index=0&id=d2939b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2939b74",
  null
  
)

export default component.exports